import React from "react"
import { Divider, Empty, Progress } from "antd"
import empty_meditions from "images/empty/anonymity.svg"
import { get } from "lodash"
import { MEASURE_STATUS } from "../../../../../utils/constants"
import { loadTexts, sanitize } from "../../../../../utils/i18n"

const EmptyStateAnonymity = ({
  measureEngagement,
  measureTotal,
  measureGeneral,
  userType,
}) =>
{

const intlEmptyStateAnonymity = loadTexts("reports_general_view").reportAdmin.emptyStateAnonymity

  return (
    <div style={{ padding: "1rem 2rem 2rem" }}>
      <Empty
        style={{ color: "#828282" }}
        image={empty_meditions}
        description={
          <span
            style={{
              margin: "24px auto 0",
              maxWidth: 480,
              display: "block",
            }}>
            <span style={{ fontWeight: 600, fontSize: 16, display: "block" }}>
              <div>¡Ooops!</div>
            </span>
            <span style={{ marginTop: 10, display: "block", width: "484px" }}>
              <div>
                <div>
                  {intlEmptyStateAnonymity.collaboratorsGrantherThan}
                  <strong>
                    {get(userType, "anonymity_check.current_used", 0)}
                  </strong>{" "}
                  {sanitize(intlEmptyStateAnonymity.toShowMoreInfo)}
                </div>
                <div>
                  <strong>{intlEmptyStateAnonymity.totalSelected}</strong>{" "}
                  {get(measureTotal, "employees", 0)} {intlEmptyStateAnonymity.collaborators}
                </div>
              </div>
            </span>
          </span>
        }
        className="ReportHome-empty-fix"
      />
    </div>
  )
}

EmptyStateAnonymity.defaultProps = { count: 1 }

export default EmptyStateAnonymity
